import styled from "styled-components";

import { BillingDataListStyledProps as Props } from "./BillingDataList.types";
import CONSTANTS from "config/constants";

const { desktop } = CONSTANTS.BREAKPOINTS;

const BillingDataListStyled = styled.div<Props>`
  flex: 1;

  .BillingDataList {
    &__item {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-bottom: 3.2rem;
      }

      &__radio {
        width: 2rem;
        height: 2rem;
        border-radius: 2rem;
        border: 0.1rem solid var(--palette-gray-s0-l80);
        background-color: var(--palette-white);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &--active {
          background-color: var(--palette-white);
          border: 0.56rem solid var(--palette-primary);
        }
      }
    }

    &__student-icon {
      margin-right: 2rem;

      path {
        fill: var(--palette-black-s0-l10);
      }
    }

    &__empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      text-align: center;
      padding: 6.4rem 0;

      &__title {
        color: var(--palette-black-s0-l10);
        font-size: 2.4rem;
        padding-bottom: 1.2rem;
        padding-top: 1.2rem;
        font-weight: 700;
        line-height: 2.64rem;
      }

      &__description {
        color: var(--palette-gray-s0-l35);
        line-height: 2rem;
        width: 60%;
        font-weight: 400;
        font-size: 1.6rem;

        @media (min-width: ${desktop}px) {
          max-width: 26.4rem;
          width: 100%;
        }
      }

      &__icon {
        background-color: var(--palette-red-h360-s73-l54-a03);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 8.8rem;
        height: 8.8rem;

        svg {
          path {
            fill: var(--palette-primary);
          }
        }
      }
    }
  }
`;

export default BillingDataListStyled;
